/* AE · Signature hero (photo) — generated by signature-hero/photo-hero/build_theme.py from photo-hero/index.html. Do not edit here. */
(() => {
/* ───────────────────────── product config ───────────────────────── */
const PRODUCTS = {
  daydream: {
    key:'daydream', name:'Daydream', theme:0,
    eyebrow:'Aromatick Daydream · Eau de Parfum',
    h1:'Sunlit tea, <em>bottled.</em>',
    sub:'Citron, black tea and Ambroxan. Made from scratch in Port St. Lucie, Florida.',
    cta:'Shop Daydream — $45', buySm:'Shop Daydream',
    top:{ k:'01 · Top notes', t:'Sicilian Lemon, Calabrian Bergamot, Orange', d:'Bright, sunny citrus. The first thing you notice when you spray it.' },
    heart:{ k:'02 · Heart', t:'Black Tea, Ginger, Cinnamon Bark', d:'A little earthy, a little spiced. This is the part people ask you about.' },
    base:{ k:'03 · Base', t:'Ambroxan, Guaiac Wood, White Musks', d:'That “your skin, but better” glow, and it lasts 8+ hours.' },
    finalH:'The Imagination vibe. <em>Not</em> the $360 price.',
    finalD:'Daydream is our own fragrance, made from scratch. You get a 50ml eau de parfum for $45.',
    ctaFinal:'Add Daydream — $45', cta10:'Try the 10ml — $14.99',
    v50:45376508199027, v10:48377865076851,
    fallback:'https://cdn.shopify.com/s/files/1/0671/1876/0051/files/rn-image_picker_lib_temp_c769e36d-e930-4e44-b273-b7d556aa91bc.webp?v=1787319630&width=900',
    label:{ title:'DAYDREAM', titleFont:'500 186px "Roboto Mono"', size:'50ml 1.7 Fl. OZ. / Eau De Parfum', notes:'Citron • Black Tea • Ambrox', paper:'#f8f8f6', ink:'#151515' },
    liquid:{ tint:'#fff8ec', dist:7.0, glow:'#0d0b08' },
  },
  horizon: {
    key:'horizon', name:'Horizon', theme:1,
    eyebrow:'Aromatick Horizon · Eau de Parfum',
    h1:'First light, <em>bottled.</em>',
    sub:'Grapefruit, ginger and Ambroxan. Made from scratch in Port St. Lucie, Florida.',
    cta:'Shop Horizon — $45', buySm:'Shop Horizon',
    top:{ k:'01 · Top notes', t:'Pink Grapefruit, Bergamot, Ginger', d:'Sharp, bright and a little spicy, right from the first spray.' },
    heart:{ k:'02 · Heart', t:'Rosemary, Sage, Geranium', d:'A green, herbal detour with a water accord. It’s the part people remember.' },
    base:{ k:'03 · Base', t:'Ambroxan, Amber, Labdanum', d:'It settles warm and clean, and stays close to the skin for 8+ hours.' },
    finalH:'The L’Immensité vibe. <em>Not</em> the $360 price.',
    finalD:'Horizon is our own fragrance, made from scratch. You get a 50ml eau de parfum for $45.',
    ctaFinal:'Add Horizon — $45', cta10:'Try the 10ml — $14.99',
    v50:45459624329331, v10:48377807241331,
    fallback:'https://cdn.shopify.com/s/files/1/0671/1876/0051/files/aromatick-horizon-eau-de-parfum-50ml-bottle.webp?v=1791046472&width=900',
    label:{ title:'Horizon', titleFont:'400 200px "Courier Prime"', size:'50ml 1.7 FL. OZ. / Eau de Parfum', notes:'Grapefruit • Ginger • Ambrox', paper:'#ebe7e0', ink:'#1d1b19' },
    liquid:{ tint:'#e0943c', dist:1.3, glow:'#361805' },
  },
};
// Meridian + Aura (added 2026-10-16). Copy rules: Meridian is a supplier compound -> "blended, bottled and labeled by hand",
// never "made from scratch" / "our own"; Aura is compounded in-house -> "compounded from scratch" is OK. LV retail $360 for both.
PRODUCTS.meridian = {
  key:'meridian', name:'Meridian',
  eyebrow:'Aromatick Meridian · Eau de Parfum',
  h1:'Poolside, <em>bottled.</em>',
  sub:'Mandarin, ginger and ambergris. Blended and bottled by hand in Port St. Lucie, Florida.',
  cta:'Shop Meridian — $45', buySm:'View Meridian',
  top:{ k:'01 · Top notes', t:'Mandarin, Orange, Bergamot', d:'Juicy, sunny citrus. The first splash when you spray it.' },
  heart:{ k:'02 · Heart', t:'Ginger, Aquatic Accord', d:'A cool, slightly spicy detour through fresh ginger and clear water. The part people ask about.' },
  base:{ k:'03 · Base', t:'Ambergris', d:'Clean, skin-like and a little salty, so the citrus never fades into nothing.' },
  finalH:'The Afternoon Swim vibe. <em>Not</em> the $360 price.',
  finalD:'Meridian is blended, bottled and labeled by hand in Port St. Lucie. You get a 50ml eau de parfum for $45.',
  ctaFinal:'Add Meridian — $45', cta10:'Try the 10ml — $14.99',
  v50:66878060920947, v10:66878060822643,
};
PRODUCTS.aura = {
  key:'aura', name:'Aura',
  eyebrow:'Aromatick Aura · Eau de Parfum',
  h1:'Starfall, <em>bottled.</em>',
  sub:'Mandarin, pink pepper and vetiver. Compounded from scratch in Port St. Lucie, Florida.',
  cta:'Shop Aura — $45', buySm:'View Aura',
  top:{ k:'01 · Top notes', t:'Mandarin, Orange, Bergamot', d:'Bright citrus with a fizz. The first thing you notice when you spray it.' },
  heart:{ k:'02 · Heart', t:'Pink, Black & Sichuan Pepper', d:'Three peppers with neroli, nutmeg and cardamom. Crisp spice that sparks against the citrus.' },
  base:{ k:'03 · Base', t:'Vetiver', d:'Clean, dry vetiver that stays close to the skin.' },
  finalH:'The Météore vibe. <em>Not</em> the $360 price.',
  finalD:'Aura is compounded from scratch in Port St. Lucie. You get a 50ml eau de parfum for $45.',
  ctaFinal:'Add Aura — $45', cta10:'Try the 10ml — $14.99',
  v50:66878164140147, v10:66878164041843,
};

const SHOTS = {"horizon": {"top": [0.579, 0.401], "heart": [0.25, 0.53], "base": [0.345, 0.615]}, "daydream": {"top": [0.563, 0.358], "heart": [0.25, 0.54], "base": [0.29, 0.62]}, "meridian": {"top": [0.542, 0.345], "heart": [0.27, 0.545], "base": [0.478, 0.585]}, "aura": {"top": [0.44, 0.45], "heart": [0.25, 0.58], "base": [0.4, 0.53]}};   // per product: image-space anchors (0..1) for the callouts
const GIANT = {"horizon": {"wide": {"x": 0.31, "y": 0.56, "size": 0.4}, "narrow": {"x": 0.43, "y": 0.56, "size": 0.26}}, "daydream": {"wide": {"x": 0.325, "y": 0.56, "size": 0.4}, "narrow": {"x": 0.44, "y": 0.56, "size": 0.26}}, "meridian": {"wide": {"x": 0.3, "y": 0.56, "size": 0.4}, "narrow": {"x": 0.42, "y": 0.56, "size": 0.26}}, "aura": {"wide": {"x": 0.312, "y": 0.56, "size": 0.4}, "narrow": {"x": 0.43, "y": 0.56, "size": 0.26}}};   // per product: { wide:{x,y,size}, narrow:{x,y,size} } in image fractions
const CROP = {"horizon": {"hero": {"fx": 0.6, "fy": 0.5, "z": 0.84}, "top": {"fx": 0.6, "fy": 0.5, "z": 1.05}, "heart": {}, "base": {}, "price": {"fx": 0.56, "fy": 0.5}}, "daydream": {"hero": {"fx": 0.6, "fy": 0.5, "z": 0.84}, "top": {"fx": 0.55, "fy": 0.5, "z": 1.05}, "heart": {}, "base": {"fx": 0.45}, "price": {"fx": 0.56, "fy": 0.5}}, "meridian": {"hero": {"fx": 0.6, "fy": 0.5, "z": 0.84}, "top": {"fx": 0.5, "fy": 0.5, "z": 1.05}, "heart": {}, "base": {}, "price": {"fx": 0.56, "fy": 0.5}}, "aura": {"hero": {"fx": 0.6, "fy": 0.5, "z": 0.84}, "top": {"fx": 0.5, "fy": 0.5, "z": 1.05}, "heart": {}, "base": {}, "price": {"fx": 0.56, "fy": 0.5}}};     // phone only: per product/shot focal point + zoom { fx, fy, z }
const ORDER = ['hero','top','heart','base','price'];

const root = document.querySelector('.ash');
if (!root) return;
const CFG = JSON.parse((root.parentElement.querySelector('.ash-data') || {}).textContent || '{}');
const $ = (s, el = root) => el.querySelector(s);
const $$ = (s, el = root) => [...el.querySelectorAll(s)];
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const qp = new URLSearchParams(location.search);
for (const k of Object.keys(PRODUCTS)) {
  const c = CFG.products?.[k] || {};
  for (const f of ['url','h1','sub','buySm']) if (c[f]) PRODUCTS[k][f] = c[f];
}
let active = PRODUCTS[root.dataset.start] ? root.dataset.start : 'horizon';

// pin under the theme's sticky header
function headerOffset(){
  const cs = getComputedStyle(document.documentElement);
  const sticky = parseFloat(cs.getPropertyValue('--header-is-sticky')) || 0;
  let h = parseFloat(cs.getPropertyValue('--header-height')) || 0;
  if (!h) { const el = document.querySelector('.shopify-section[id$="__header"], header'); h = el ? el.offsetHeight : 0; }
  return sticky ? h : 0;
}
const syncHdr = () => root.style.setProperty('--ash-hdr', headerOffset() + 'px');
syncHdr();

function fillCopy(p){
  $$('[data-c]').forEach(el => {
    const path = el.dataset.c.split('.');
    let v = p; for (const k of path) v = v?.[k];
    if (v != null) el.innerHTML = v;
  });
  $$('[data-for]').forEach(el => { el.hidden = el.dataset.for !== p.key; });
  $$('[data-url]').forEach(a => { if (p.url) a.href = p.url; });
  $$('.ash-tab').forEach(t => t.setAttribute('aria-selected', String(t.dataset.p === p.key)));
  const pill = $('.ash-buy-sm'); if (pill && p.buySm) pill.setAttribute('aria-label', p.buySm);
  root.dataset.theme = p.key;
}
fillCopy(PRODUCTS[active]);

const sets = Object.fromEntries($$('.ash-set').map(s => [s.dataset.p, s]));
sets[active].classList.add('on');
// images load per product: the active set now, the other products' hero shots when idle, a full set on hover/tap of its tab
function loadSet(p, all){
  if (!sets[p]) return;
  sets[p].querySelectorAll('img[data-src]').forEach(img => {
    if (all || img.closest('[data-s=hero]')) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
  });
}
loadSet(active, true);
setTimeout(() => Object.keys(sets).forEach(p => loadSet(p, false)), 2500);
$$('.ash-tab').forEach(t => ['pointerenter','focus','touchstart'].forEach(ev => t.addEventListener(ev, () => loadSet(t.dataset.p, true), { passive:true })));
// shot weights 0..1 per chapter (shared by both products; only the active set is visible)
const W = { hero:1, top:0, heart:0, base:0, price:0 };
const Z = { hero:1, top:0, heart:0, base:0, price:0 };   // per-shot push-in progress
function paintShots(){
  for (const s of Object.values(sets)) ORDER.forEach(k => {
    const el = s.querySelector(`[data-s=${k}]`);
    el.style.opacity = W[k];
  });
  for (const s of Object.values(sets)) s.querySelector('.ash-bottle').style.opacity = W.price;
}

function setProduct(k){
  if (k === active) return;
  const prev = active; active = k;
  const d = reduced ? 0 : 1.1;
  gsap.to(sets[prev], { opacity:0, duration:d, ease:'power2.inOut', onComplete(){ sets[prev].classList.remove('on'); } });
  loadSet(k, true);
  sets[k].classList.add('on'); gsap.fromTo(sets[k], { opacity:0 }, { opacity:1, duration:d, ease:'power2.inOut' });
  const copies = $$('.ash-copy');
  root.dataset.theme = k;
  if (!d) { fillCopy(PRODUCTS[k]); layout(); return; }
  gsap.to(copies, { opacity:0, y:8, duration:.25, ease:'power1.in', onComplete(){
    fillCopy(PRODUCTS[k]); layout();
    gsap.to(copies, { opacity:1, y:0, duration:.5, ease:'power2.out', stagger:.03 });
  }});
}
$$('.ash-tab').forEach(t => t.addEventListener('click', () => setProduct(t.dataset.p)));

/* scroll timeline: same chapter timing and labels as the 3D version */
const S = { top:0, heart:0, base:0, giant:0 };
const P = { hero:$('.ash-hero'), top:$('[data-ch=top]'), heart:$('[data-ch=heart]'), base:$('[data-ch=base]'), price:$('[data-ch=price]'), hint:$('.ash-hint') };
const IN = { autoAlpha:1, y:0, duration:.5, ease:'power2.out' };
const OUT = { autoAlpha:0, y:-30, duration:.4, ease:'power1.in' };
// crossfade a -> b with a push-in on the incoming shot
const swap = (a, b, at, dur) => tl
  .to(W, { [a]:0, duration:dur*0.8, ease:'power1.inOut', onUpdate:paintShots }, at + dur*0.2)
  .to(W, { [b]:1, duration:dur*0.8, ease:'power1.inOut', onUpdate:paintShots }, at)
  .fromTo(Z, { [b]:0 }, { [b]:1, duration:dur + 1.4, ease:'power2.out' }, at);
const tl = gsap.timeline({ paused:true, defaults:{ ease:'power2.inOut' } });
tl.addLabel('hero', 0)
  .to(P.hint, { autoAlpha:0, duration:.3, ease:'none' }, 0.05)
  .to(P.hero, { autoAlpha:0, y:-40, duration:.6, ease:'power1.in' }, 0.5);
swap('hero', 'top', 1.0, 1.5);
tl.fromTo(P.top, { autoAlpha:0, y:30 }, IN, 2.3)
  .to(S, { top:1, duration:.6, ease:'power2.out' }, 2.45)
  .addLabel('top', 2.95)
  .to(S, { top:0, duration:.3, ease:'none' }, 3.85)
  .to(P.top, OUT, 3.9);
swap('top', 'heart', 4.0, 1.4);
tl.fromTo(P.heart, { autoAlpha:0, y:30 }, IN, 5.3)
  .to(S, { heart:1, duration:.6, ease:'power2.out' }, 5.45)
  .addLabel('heart', 5.95)
  .to(S, { heart:0, duration:.3, ease:'none' }, 6.65)
  .to(P.heart, OUT, 6.7);
swap('heart', 'base', 6.8, 1.4);
tl.fromTo(P.base, { autoAlpha:0, y:30 }, IN, 8.1)
  .to(S, { base:1, duration:.6, ease:'power2.out' }, 8.25)
  .addLabel('base', 8.75)
  .to(S, { base:0, duration:.3, ease:'none' }, 9.45)
  .to(P.base, OUT, 9.5);
swap('base', 'price', 9.6, 1.4);
tl.to(S, { giant:1, duration:1.3, ease:'power2.out' }, 10.3)
  .fromTo(P.price, { autoAlpha:0, y:30 }, { ...IN, duration:.6 }, 11.0)
  .addLabel('price', 11.6)
  .to({}, { duration:.8 }, 11.6);

let st = null;
const nextSec = root.parentElement.nextElementSibling;
const useCurtain = !reduced && CFG.curtain !== false && !!nextSec && nextSec.classList.contains('shopify-section');
function curtainOverlap(){ return useCurtain ? Math.round(Math.min(nextSec.offsetHeight, innerHeight - headerOffset())) : 0; }
function applyCurtain(){
  if (!useCurtain) return;
  const o = curtainOverlap();
  nextSec.classList.add('ash-curtain-next'); nextSec.style.marginTop = (-o) + 'px';
  root.style.setProperty('--ash-overlap', o + 'px');
}
applyCurtain();
if (!reduced) st = ScrollTrigger.create({ trigger:root, start:() => `top ${headerOffset()}px`, end:() => `bottom-=${curtainOverlap()} bottom`, scrub:1.1, animation:tl, invalidateOnRefresh:true });
function goTo(label){
  if (!st) return;
  const y = st.start + (tl.labels[label] / tl.duration()) * (st.end - st.start);
  gsap.to(window, { scrollTo:y, duration:Math.min(2.4, 0.8 + Math.abs(y - scrollY) / 2500), ease:'power2.inOut' });
}
$$('[data-go]').forEach(b => b.addEventListener('click', () => goTo(b.dataset.go)));
const chapBtns = $$('.ash-chap'), navEl = $('.ash-chapters');

/* pointer parallax (hero + price only) */
let mx = 0, my = 0, sx = 0, sy = 0;
addEventListener('pointermove', e => { mx = e.clientX / innerWidth * 2 - 1; my = e.clientY / innerHeight * 2 - 1; }, { passive:true });

/* callouts: anchor = image-space point of the active product's shot, mapped through the shot's current transform */
const stage = $('.ash-stage'), sticky = $('.ash-sticky');

/* narrow screens: photo on top, copy below it; size the photo from what the tallest panel leaves, so they never overlap */
const panels = $$('.ash-panel'), scrim = $('.ash-scrim');
const PT = { hero:0, top:0, heart:0, base:0, price:0 };   // phone panel tops
let narrow = innerWidth <= 760;
function layout(){
  narrow = innerWidth <= 760;
  if (!narrow){
    stage.style.width = ''; stage.style.top = '';
    const H = sticky.clientHeight;   // centred; the active callout panel is re-placed every frame by updateCallouts
    panels.forEach(pn => { pn.style.top = Math.round((H - pn.offsetHeight) / 2) + 'px'; pn.style.bottom = 'auto'; });
    return;
  }
  stage.style.width = ''; stage.style.top = '';
  const H = sticky.clientHeight, bottomPad = 0.07 * H + 10;
  panels.forEach(pn => {
    const t = Math.round(H - pn.offsetHeight - bottomPad);
    pn.style.top = t + 'px'; pn.style.bottom = 'auto'; PT[pn.dataset.ch || 'hero'] = t;
  });
}
layout();
addEventListener('resize', () => { syncHdr(); applyCurtain(); layout(); requestAnimationFrame(layout); ScrollTrigger.refresh(); });
addEventListener('load', () => { syncHdr(); applyCurtain(); layout(); ScrollTrigger.refresh(); });
document.fonts && document.fonts.ready.then(layout);
const lines = Object.fromEntries(['top','heart','base'].map(k => {
  const g = $(`[data-line=${k}]`); return [k, { line:g.querySelector('line'), ring:g.querySelector('.ring'), dot:g.querySelector('.dot') }];
}));
const scaleOf = k => 1.1 - 0.1 * Z[k];          // push-in: 1.10 -> 1.00
let SW = 1, SH = 1;                              // stage size, refreshed each frame
// where a shot's square image sits in the stage: cover-crop around a focal point (phone), plain fill (desktop square)
function geo(p, k){
  const c = (narrow && CROP[p] && CROP[p][k]) || {};
  const z = c.z ?? 1, fx = c.fx ?? 0.5, fy = c.fy ?? 0.5;
  const C = Math.max(SW, SH) * z;
  const left = C < SW ? (SW - C) / 2 : Math.min(0, Math.max(SW - C, SW / 2 - fx * C));
  const top = C < SH ? 0 : Math.min(0, Math.max(SH - C, SH / 2 - fy * C));
  return { C, left, top };
}
// image fraction -> stage px, including the push-in scale about the stage centre
function toStage(p, k, u, v){
  const g = geo(p, k), s = scaleOf(k);
  return [SW / 2 + (g.left + u * g.C - SW / 2) * s, SH / 2 + (g.top + v * g.C - SH / 2) * s];
}
function anchorXY(k){
  const a = SHOTS[active][k], r = stage.getBoundingClientRect(), sr = sticky.getBoundingClientRect();
  const [x, y] = toStage(active, k, a[0], a[1]);
  return [r.left - sr.left + x, r.top - sr.top + y];
}
function updateCallouts(t){
  const wide = !narrow, H = sticky.clientHeight;
  for (const k of ['top','heart','base']){
    const L = lines[k], prog = S[k];
    if (prog <= 0.001){ ['x1','x2','y1','y2'].forEach(n => L.line.setAttribute(n, 0)); L.ring.setAttribute('r',0); L.dot.setAttribute('r',0); continue; }
    const [ax, ay] = anchorXY(k);
    const panel = P[k], rule = panel.querySelector('.ash-rule');
    if (wide){
      const pr = panel.getBoundingClientRect(), rr0 = rule.getBoundingClientRect();
      const top = Math.max(80, Math.min(H - pr.height - 40, ay - (rr0.top - pr.top)));
      panel.style.top = top + 'px';
    }
    const rr = rule.getBoundingClientRect(), sr = sticky.getBoundingClientRect();
    const x1 = wide ? rr.right - sr.left : rr.left - sr.left + 28;
    const y1 = wide ? rr.top - sr.top + 0.5 : panel.getBoundingClientRect().top - sr.top - 14;
    const e = Math.min(1, prog / 0.85);
    L.line.setAttribute('x1', x1); L.line.setAttribute('y1', y1);
    L.line.setAttribute('x2', x1 + (ax - x1)*e); L.line.setAttribute('y2', y1 + (ay - y1)*e);
    const dotK = Math.max(0, (prog - 0.8) / 0.2);
    L.dot.setAttribute('cx', ax); L.dot.setAttribute('cy', ay); L.dot.setAttribute('r', 3.5*dotK);
    const pulse = (t*0.8) % 1;
    L.ring.setAttribute('cx', ax); L.ring.setAttribute('cy', ay); L.ring.setAttribute('r', (8 + pulse*16)*dotK);
    L.ring.style.opacity = (1 - pulse) * dotK;
  }
}

let running = true;
new IntersectionObserver(([en]) => { running = en.isIntersecting; }, { rootMargin:'100px' }).observe(root);
const t0 = performance.now();
function frame(){
  requestAnimationFrame(frame);
  if (!running || document.hidden || (st && scrollY > st.end + innerHeight)) return;
  const t = reduced ? 2 : (performance.now() - t0) / 1000;
  sx += (mx - sx) * 0.05; sy += (my - sy) * 0.05;
  SW = stage.clientWidth; SH = stage.clientHeight;
  if (narrow){
    const wsum = ORDER.reduce((a, k) => a + W[k], 0) || 1;
    const pt = ORDER.reduce((a, k) => a + W[k] * PT[k], 0) / wsum;
    scrim.style.top = Math.round(pt - 100) + 'px';
  } else scrim.style.top = '';
  const par = narrow ? 0 : W.hero + W.price;     // parallax only on the full-bottle shots, desktop only
  for (const [p, s] of Object.entries(sets)) ORDER.forEach(k => {
    if (!s.classList.contains('on')) return;          // hidden products: nothing to place
    const g = geo(p, k), sc = scaleOf(k);
    const bob = (k === 'hero' || k === 'price') ? Math.sin(t*0.9) * 0.6 : 0;
    const tf = `translate(${(g.left - sx*10*par).toFixed(2)}px, ${(g.top - sy*8*par + bob).toFixed(2)}px) scale(${sc.toFixed(4)})`;
    const og = `${(SW / 2 - g.left).toFixed(1)}px ${(SH / 2 - g.top).toFixed(1)}px`;   // scale about the stage centre
    const imgs = [s.querySelector(`[data-s=${k}] img`)];
    if (k === 'price') imgs.push(s.querySelector('.ash-bottle img'));
    imgs.forEach(img => { img.style.width = img.style.height = g.C.toFixed(1) + 'px'; img.style.transformOrigin = og; img.style.transform = tf; });
    if (k === 'price'){
      const gd = GIANT[p][narrow ? 'narrow' : 'wide'], [x, y] = toStage(p, 'price', gd.x, gd.y), el = s.querySelector('.ash-giant');
      el.style.fontSize = (gd.size * g.C * sc).toFixed(1) + 'px';
      el.style.left = (x + (1 - S.giant) * 0.06 * SW).toFixed(1) + 'px'; el.style.top = y.toFixed(1) + 'px';
      el.style.opacity = S.giant;
    }
  });
  updateCallouts(t);
  const c = tl.time(), chap = c < 1.8 ? -1 : c < 4.6 ? 0 : c < 7.4 ? 1 : c < 10.2 ? 2 : 3;
  chapBtns.forEach((btn, k) => btn.classList.toggle('on', k === chap));
  const navA = Math.min(1, Math.max(0, (c - 1.2) / 0.8));
  navEl.style.opacity = navA; navEl.style.visibility = navA > 0.01 ? 'visible' : 'hidden';
}
paintShots(); frame();
root.__ash = { tl, setProduct, goTo };
})();
